/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
import { parse } from 'query-string';

export const INTERNAL_DOMAINS = ['immobilienscout24.de', 'localhost', '127.0.0.1'];

export function setSearchParams(name, value, oldSearch = window.location.search) {
  let isParamFoundAndUpdated = false;
  const newSearchParts = oldSearch
    .replace('?', '')
    .split('&')
    .filter((s) => s !== '')
    .map((part) => {
      if (part.startsWith(`${name}=`)) {
        isParamFoundAndUpdated = true;
        return `${name}=${value}`;
      }
      return part;
    });
  if (!isParamFoundAndUpdated) {
    newSearchParts.push(`${name}=${value}`);
  }

  return `?${newSearchParts.join('&')}`;
}

export function appendSearchParamsToUrl(urlLink) {
  const relativeUrlLink = urlLink.replace('https://atlas.immobilienscout24.de', '');
  const locationSearch = typeof window === 'object' ? window.location.search : '';

  return `${relativeUrlLink}${locationSearch}`;
}

function createQueryParamStr(key, value) {
  if (Array.isArray(value)) {
    return value.map((val) => createQueryParamStr(key, val)).join('&');
  }
  return `${key}=${value}`;
}

export function generateQueryStr(queryParams = {}) {
  return Object.keys(queryParams)
    .map((key) => createQueryParamStr(key, queryParams[key]))
    .join('&');
}

export function getSearchParam(paramName, queryParams = window.location.search) {
  return parse(queryParams)[paramName];
}

export const getHashParam = (hash, param) => {
  const hashParams = hash.substr(hash.indexOf('?'));
  return parse(hashParams)[param];
};

export function getDocumentReferer() {
  // When comming form imperva, the original referer for the request is first stored in
  // sessionStorage. When tealium runs, it deletes the value from sessionStorage and saves it
  // to document.referer. We need to cover both cases (before and after document.referer is set)
  // because we don't know if we are running before or after tealium.
  const documentReferrer = document.referrer;
  let sessionStorageReferrer = null;
  try {
    sessionStorageReferrer = sessionStorage.getItem('distil_referrer');
  } catch {}
  return sessionStorageReferrer || documentReferrer;
}

export function isInternalReferer(referer) {
  return referer ? INTERNAL_DOMAINS.some((x) => referer.includes(x)) : false;
}
